import {BaseWrapper} from '../../../allkey/framework/parameters/BaseWrapper';
import {Style} from '../message/Style';
import {StyleCriteria} from './StyleCriteria';
import {StyleScenario} from './StyleScenario';

export class StyleWrapper extends BaseWrapper<Style, StyleCriteria, StyleScenario>  {}

